import Action from '../Action'
// import './styles/ImportInfo.css'
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import SelectorIcons from '../SelectorIcons';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import { importFunction } from '../../utils/utils';
import Search from "../generales/Search";
import Paginador from "../generales/Paginador";
import InputForm from '../generales/InputForm';
const ImportExterna =({handleShowPopup,users_catalog,buscar_cis,server,languaje,mode,importLoading,closeImportModal,setImportLoading})=>{
  const [file, setFile] = useState(null);
  const [disabled,setDisabled]=useState(true)
  const [msgError,setMsgError]=useState(true)
  const [boolError,setBoolError]=useState(false)
  const [response,setResponse]=useState([])
  const [fileContent, setFileContent] = useState(null);
  const [tableData, setTableData] = useState([]);

  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  var dataList = searchTerm === "" ? tableData.slice(1) : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const fileInputRef = useRef(null);

  const handleFileClick = () => {
    fileInputRef.current.click(); // Simula el clic en el input file oculto
  };
  // // Función para manejar la selección de archivo
  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]);
  // };
  const [doc_id ,setDocid]=useState(0)
  const [loadingDownload,setLoadingDownload]=useState(false)
  const handledownloadDocClick=()=>{
   
           setLoadingDownload(true)
   const fetchDataPost = async () => {
     // console.log(server.url+'/api/v1/cassia/cis_v2/{ci_id}/documents/'+elemento.id+'/download')
  try {
    const response = await fetch(server.url+'/api/v1/cassia/cis_v2/excel_template', {
   
      method: 'GET',  
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    if (response.ok) {
        try {
          const response_data = await response.blob();

          // Crear un enlace para descargar el archivo
          const url = window.URL.createObjectURL(response_data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download','plantilla_cis'); // Cambia el nombre y la extensión del archivo
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoadingDownload(false)
          handleShowPopup('Completado','Archivo descargado correctamente','', true)
        } catch (error) {
            console.error('Error al descargar el archivo', error);
          }
      
    //   setResponseDetail({text:data1.message,value:true})
    //   const timer = setTimeout(() => {
    //       setResponseDetail({text:'',value:true})
    //     }, 2000);
        
    } else {
      throw new Error('Error en la solicitud');
    }
  } catch (error) {
       
       console.error(error);
     }
   };

   fetchDataPost();
  }

  // Función para manejar la importación
  const handleImport = async () => {
      setResponse([])
    if (!file) {
      alert('Por favor selecciona un archivo');
      return;
    }

    const formData = new FormData();
    formData.append('file', file); // Agregamos el archivo seleccionado al FormData
formData.append('auth_user', cisData.auth_user);
formData.append('user_comment', cisData.user_comment);
formData.append('request_user', cisData.request_user);
    setImportLoading(true);

    try {
      const response = await fetch(server.url + '/api/v1/cassia/cis_v2/excel_import', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: formData, // Enviamos el FormData con el archivo
      });
      // const data1 = await response.json();
      // console.log(data1)
      if (response.ok) {
        const data1 = await response.json();
        setResponse(data1.data)
        const keys = Object.keys(data1.data[0]);
        const r_ok=data1.data.filter(item => item.hostid_creado	 !== "").length
        const r_error=data1.data.filter(item => item.hostid_creado	 === "").length
        // console.log(r_ok,r_error)
        const values = data1.data.map(obj => Object.values(obj));

        // Unir las claves con los valores
        const result = [keys, ...values];
        if(r_ok==0){
          handleShowPopup('Error!!!',capitalizeFirstLetter((lang[languaje]['importError'])),capitalizeFirstLetter((lang[languaje]['msgImporAll'])), false)
        }else{
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['importCorr'])),(r_error!=0)?capitalizeFirstLetter((lang[languaje]['msgImpor'])):'', true)
        }

        setFileContent(result);
        setTableData(result);
        setDisabled(true)
        setImportLoading(false);
        setBoolError(false);
        closeImportModal()
        buscar_cis()
      } else {
        const data1 = await response.json();
        setImportLoading(false);
        setBoolError(true);
        handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),data1.detail, false)
        setMsgError(data1.detail);
        throw new Error('Error en la importación');
      }
    } catch (error) {
      setImportLoading(false);
      handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),'Se produjo un error interno', false)

      // setBoolError(true);
      // setMsgError('Error al importar archivo');
      // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
      console.error('Error al importar archivo:', error);
    }
  };

  useEffect(()=>{
      if(tableData.length!=0 && response.length==0){
          setDisabled(false)
      }else{
          setDisabled(true)
      }
  },[tableData])
  // Función para leer el archivo
  const handleFileChange = (e) => {
    setResponse([])
    const file = e.target.files[0];
    setFile(file)
    importFunction(file,setFileContent,setTableData)
  };
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    // setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  // Renderizar la tabla
  const renderTable = () => { 
    if (!tableData.length) return null;

    return (
      //         <div className="cont-table-portafolio border-table" style={{overflow:'auto'}}>
      //       <div className={"head-table-portafolio"+mode} style={{width: '300%'}}>
      //       <div className="compact-head-table-portafolio">
      //       {tableData[0].map((header, index) => (
      //     //           <th key={index}>{header}</th
      //     <div className="field-head-table-mantenimiento field-larger"  key={index} style={{width:'25%'}}>  {header} </div>
      //             ))}
      //         </div>
      //       </div>
      //       <div className="body-table-portafolio" style={{overflowY:'auto',width: '300%'}}>
      //       {tableData.slice(1).map((row, rowIndex) => (
      //          <div
      //          className={"row-table-portafolio"+mode}
      //          key={rowIndex}
      //          style={{height:'40px'}}
      //        >
      //           {row.map((cell, cellIndex) => (
      //             (row.length>22)?

      //    <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)',color:((row[row.length-1]=="")?'red':'var(--green)')}} key={cellIndex}>
      //    {cell}
      //  </div>:
      //  <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
      // {cell}
      // </div>
      //               ))}

      //        </div>

      //           ))}
      //       </div>
      //     </div>
      <>
        <div className='head-cis'>
         <div className='title-cis'>
                     <Search
                         searchResults={searchResults}
                         setSearchResults={setSearchResults}
                         searchTerm={searchTerm}
                         setSearchTerm={setSearchTerm}
                         onSearch={handleSearch}
                         dataObject={tableData.slice(1)}
                         setDataObject={setDataUsers}
                         searchResult={searchResult}
                         setSearchResult={setSearchResult}
                         languaje={languaje}
                       />
               <div className={"cont-result-registers"+mode}>
              
                       <p style={{  textAlign: "center" }}>
                         &nbsp;
                         {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                           dataList.length +
                           ") " 
                           }
                       </p> 
               </div>
              
                     </div>
                     
                 </div>
        <div className='cont-cis'>
        <>
  <div className="main-panel-cis">
  <div className="compact-content-portafolio">
  {/* <div className={"content-portafolio-head"+mode}>
    
          </div> */}
    <div className="content-portafolio">
      <div className="cont-portafolio-table">
        <div className="content-card-portafolio" id="content">
           <div className="cont-table-portafolio border-table" style={{overflow:'auto',height:'100%'}}>
   <div className={"head-table-portafolio"+mode} style={{width: '300%'}}>
  <div className="compact-head-table-portafolio">
   {tableData[0].map((header, index) => (
          
<div className="field-head-table-mantenimiento field-larger"  key={index} style={{width:'25%'}}>  {header} </div>
        ))}
    </div>
  </div>
  <div className="body-table-portafolio" style={{overflowY:'auto',width: '300%'}}>
  {dataList.map((row, rowIndex) => (
     <div
     className={"row-table-portafolio"+mode}
     key={rowIndex}
     style={{height:'40px'}}
   >
      {row.map((cell, cellIndex) => (
        (row.length>17)?
        
<div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)',color:((row[row.length-6]=="Error")?'red':'var(--green)')}} key={cellIndex}>
{cell}
</div>:
<div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
{cell==""?"N/A":cell}
</div>
          ))}
     
   </div>

      ))}
  </div>
</div>
        </div>
      </div>

      </div>
      <div className={"content-portafolio-footer"+mode}>
      <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
        
        
      </div>  
      <div className="cont-display-paginador">
                <Paginador  pages={pages}
                            pageActual={pageActual}
                            setPageActual={setPageActual}
                            mode={mode}></Paginador>
      </div>
      <div className="cont-display-paginador">
        <div className={"cont-half-display-paginador"+mode}>
                  
        <div>
  <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
  <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
    <option value={10}>10</option>
    <option value={50} >50</option>
    <option value={100}>100</option>
    <option value={500}>500</option>
    <option value={1000}>1000</option>
  </select>

  
</div>
        </div>
        <div className={"cont-half-display-paginador"+mode}>
        <p style={{  textAlign: "center" }}>
                        &nbsp;
                        {"(" +
                    (startLimit + 1) +
                    " - " +
                    (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                      ?  parseInt(pageActual ) * parseInt(limitList)
                      : dataList.length) +
                    ")  "+lang[languaje]['de']+" " +
                    dataList.length +
                    " "+lang[languaje]['resultados']}
                  </p>
              
        </div>
      </div>  
                
    </div>
    </div>
  </div>
  
</>
            
        </div>
      </>
    );
  };
  const [cisData,setCisData]=useState({
       request_user:"",
       auth_user:"",
       user_comment:"",
   })
  const handleChange=(e)=>{
    const {name,value}=e.target

    setCisData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const changeOption=(option,index)=>{
 
    setCisData((prevState)=>{
           return {
               ...prevState,
               [option.filter]:option.label
           }
           
       })
       
}
  const handleTextAreaChange = (event) => {
    setCisData((prevState)=>{
        return {
            ...prevState,
            ['user_comment']:event.target.value
        }
        
    })
  };
  const {
  request_user,user_comment,
  auth_user}=cisData;
  return (
      <>
      <div className="cont-import-GS-box"> 
                      <div className='row-cont-input-file'>
                          {
                              (importLoading)?<div className='txtCantData'>
                              {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])+'...'}
                      </div>:
                              <div className="file-input-container">
                              <input 
                              accept=".json,.csv,.xlsx"
                                  type="file" 
                                  ref={fileInputRef} 
                                  style={{ display: 'none' }} 
                                  onChange={ handleFileChange}
                              />
                              <button className="custom-file-button" onClick={handleFileClick}>
                                 {capitalizeFirstLetter(lang[languaje]['selectFile'])}
                              </button>
    
                              <span id="file-name">
                                  {(fileInputRef.current?.files[0]==undefined)?capitalizeFirstLetter(lang[languaje]['sinArchivo']):(fileInputRef.current?.files[0].name || capitalizeFirstLetter(lang[languaje]['sinArchivo']))}
                              </span>
                          </div>
                          }
                          <div className="cont-buttons-panel" style={{right:'0%', width:'15%', top:'0%'}}>
                
        {loadingDownload?
                <LoadSimple></LoadSimple>:
                <Action
                  disabled={false}
                  origen="Green"
                  titulo={" "+'descargar plantilla'}
                  action={handledownloadDocClick}
                />}
            </div>
                      </div>
                      <div className='row-cont-input-file' style={{height:'40%'}}> 
                        <div className={"compact-body-step-modal "}>
                                          <div className="row-form-modal">
                  <div className="colum-form-modal">
                      {/* {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                      <InputForm optionDefault={0} type='selector' endpoint='Users'msgError={'El Solicitante y Autorizador no pueden ser iguales'}  error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'request_user'} titulo={'Solicitante'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.request_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                      } */}
                    <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'request_user'} titulo={'Solicitante'} text={cisData.request_user} placeHolder={''} disabled={false} isRequired={true}/>
                      
                      </div>
                <div className="colum-form-modal">
                      {/* {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                      <InputForm optionDefault={0} type='selector' endpoint='Users' msgError={'El Solicitante y Autorizador no pueden ser iguales'} error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'auth_user'} titulo={'Autorizador'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.auth_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                      } */}
                       <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'auth_user'} titulo={'Autorizador'} text={cisData.auth_user} placeHolder={''} disabled={false} isRequired={true}/>

                  </div>
                </div>
                                          
                                          <div className="row-form-modal">
                                            <div className="colum-form-modal">
                                                {/* {(dataClasifications.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                                                <InputForm optionDefault={0} type='selector' endpoint='field_option'msgError={''}  error={false} changeOption={changeOption}  attr={'classification_id'} titulo={'Clasificacion'} loading={dataClasifications.loading} data={dataClasifications.data.data} text={''} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={cisData.classification_id==null}/>
                                                } */}
                                                </div>
                                          
                                          </div>
                                           <div className="row-form-modal-dobel">
                                                <InputForm type='textArea'  error={false} handleInputChange={handleChange}  attr={'user_comment'} titulo={'Comentarios'} text={cisData.user_comment} placeHolder={'Agregar comentarios'} disabled={false} isRequired={cisData.user_comment.length<5} coment={'(minimo 5 caracteres)'}/>
                        
                                          </div>
                                         
                                        </div>
                        {/* <div className="form-GS-box">
                          <div className="user-box-GS" style={{height:'25%'}}>
                                      
                                  <input  name="request_user"  type="text" value={request_user}
                                  onChange={handleChange} />
                                      <label className='label-GS' style={{height:'10%'}}>{"Solicitante"}</label> 
                                      {
                                          // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                      }
                                      
                                  </div>
                                   <div className="user-box-GS" style={{height:'25%'}}>
                                     
                                  <input  name="auth_user"  type="text" value={auth_user}
                                  onChange={handleChange} />
                                      <label className='label-GS' style={{height:'10%'}}>{"Autorizador"}</label> 
                                      {
                                          // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                      }
                                      
                                  </div>
                                  <div className="user-box-GS" style={{height:'50%'}}>
              
                <textarea maxlength="2000" style={{background:'background: var(--white-color)',position:'relative',resize:'none',width:'100%'}} id="nota" name="nota" className="CmtAuth" rows="3" cols="15" value={user_comment}  onChange={handleTextAreaChange}></textarea>
                                      <label className='label-GS' style={{top:'0%'}}>{'Comentarios'}</label> 
                              </div>
                          </div> */}
                      </div>
                      <div className='row-cont-input-table' >
                      
    
    
      {fileContent ? renderTable() : <div className="cont-table-portafolio border-table msgImport"><p>{capitalizeFirstLetter(lang[languaje]['sinArchivo'])}.</p></div>}
    
                      <div className='row-cont-input-file' style={{overflow:'auto',justifyContent:'center'}}>
                              {((boolError)?
                              
                          <div style={{width:'80%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>
                             <div className="cont-msg-alert-confirm-action" style={{height:'100%'}}>
                          <div className="compact-msg-alert-confirm-action" style={{background:'rgba(255, 166, 156, 0.59)',borderColor:'rgba(191, 18, 0, 0.59)'}}>
                              <img  className='icon-msg-alert' src={"/iconos/cancel.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                              <div className="msg-alert-txt-confirm-action">
                              {msgError}

                                 
                              </div>
                          </div>
                          
                      </div>
                          </div>
                              :
                                  (tableData.length==0)?'':
                                      ((response.length==0)?
                                          capitalizeFirstLetter(lang[languaje]['registrosCargar'])+': '+(tableData.length-1):
                                              <>
                                                  <div style={{color:'var(--green)'}}>{capitalizeFirstLetter(lang[languaje]['registrosCorrectos'])+':'+response.filter(item => item.status	 !== "Error").length}</div> &nbsp;&nbsp;&nbsp;
                                                  <div style={{color:'red'}}>{capitalizeFirstLetter(lang[languaje]['registrosIncorrectos'])+':'+response.filter(item => item.status	 === "Error").length}</div>
                                              </>
                                              ))}
                      </div>
                      </div>
                      <div className='row-cont-input-buttons'>
                      {(importLoading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%',width:'100%'}}><LoadSimple></LoadSimple></div>:
                      (
                      <>
                      <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(((response.length==0)?lang[languaje]['cancelar']:lang[languaje]['cerrar']))}  action={closeImportModal}/>
                      <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['importar'])}  action={handleImport}/>
                      </>
                      )
                      }
                      </div>           
                  </div>
      </>
  )
}

export default ImportExterna